import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  TEST_CASE_AUTOMATION_STATUSES,
  TEST_CASE_STATUSES,
  TEST_CASE_TYPES,
  TEST_TYPES,
} from '../models/test-case.model';

export type TcValueList = 'type' | 'testType' | 'status' | 'automationStatus';

const STANDARD_KEYS: Record<TcValueList, readonly string[]> = {
  type: TEST_CASE_TYPES,
  testType: TEST_TYPES,
  status: TEST_CASE_STATUSES,
  automationStatus: TEST_CASE_AUTOMATION_STATUSES,
};

function i18nKey(list: TcValueList, value: string): string {
  return list === 'automationStatus'
    ? `testCases.form.automation.status.${value.toLowerCase()}`
    : `testCases.${list}.${value}`;
}

// Standardwerte laufen immer über i18n; eigene Werte des Projekts haben meist keinen Text und zeigen dann ihren Schlüssel.
export function tcValueLabel(translate: TranslateService, list: TcValueList, value: string | null | undefined): string {
  if (!value) return '';
  const key = i18nKey(list, value);
  const label = translate.instant(key);
  if (STANDARD_KEYS[list].includes(value)) return label;
  return label === key ? value : label;
}

export function standardValuesFirst(standard: readonly string[], values: Iterable<string>): string[] {
  const present = new Set(values);
  const own = [...present].filter((value) => !standard.includes(value)).sort();
  return [...standard.filter((value) => present.has(value)), ...own];
}

// Nicht rein wie die TranslatePipe: Übersetzungen laden asynchron und die Sprache wechselt zur Laufzeit.
@Pipe({ name: 'tcValueLabel', standalone: true, pure: false })
export class TcValueLabelPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | null | undefined, list: TcValueList): string {
    return tcValueLabel(this.translate, list, value);
  }
}
